import React from 'react';

const FAILED_PREFIX = 'Existen inscripciones que fallaron ';
const PARTIAL_SUCCESS_SUFFIX = ' En las materias no mencionadas la inscripción fue exitosa.';
const INTRO_TEXT = 'Algunas inscripciones no se pudieron completar:';

function normalizeInscripcionErrorItem(item) {
  return item
    .replace(/^La inscripción\s+a cursar no se llevó a cabo:\s*/i, '')
    .replace(/^La inscripción\s+no se pudo llevar a cabo[^:]*:\s*/i, '')
    .trim();
}

export function parseInscripcionExamenErrors(message) {
  const raw = (message || '').trim();
  if (!raw) {
    return { items: [], intro: null, footer: null, single: '' };
  }

  let text = raw;
  let footer = null;

  if (text.includes(PARTIAL_SUCCESS_SUFFIX)) {
    footer = 'En las materias no mencionadas, la inscripción fue exitosa.';
    text = text.replace(PARTIAL_SUCCESS_SUFFIX, '').trim();
  }

  let intro = null;
  if (text.startsWith(FAILED_PREFIX)) {
    intro = INTRO_TEXT;
    text = text.slice(FAILED_PREFIX.length).trim();
  }

  if (!text.includes('|')) {
    const singleItem = normalizeInscripcionErrorItem(text);
    if (intro && singleItem) {
      return { items: [singleItem], intro, footer, single: null };
    }
    return { items: [], intro: null, footer, single: text || null };
  }

  const items = text
    .split('|')
    .map((item) => normalizeInscripcionErrorItem(item))
    .filter(Boolean);

  return { items, intro, footer, single: null };
}

export function InscripcionExamenErrorMessage({ message, className = 'md-form-page__error' }) {
  const parsed = parseInscripcionExamenErrors(message);

  if (parsed.single) {
    return (
      <div className={className} role="alert">
        <p>{parsed.single}</p>
        {parsed.footer ? (
          <p className="md-inscripcion-examen__errors-footer">{parsed.footer}</p>
        ) : null}
      </div>
    );
  }

  return (
    <div className="md-inscripcion-examen__errors" role="alert">
      {parsed.intro ? (
        <p className="md-inscripcion-examen__errors-intro">{parsed.intro}</p>
      ) : null}
      <ul className="md-inscripcion-examen__errors-list">
        {parsed.items.map((item, index) => (
          <li key={`${index}-${item}`} className="md-inscripcion-examen__errors-item">
            {item}
          </li>
        ))}
      </ul>
      {parsed.footer ? (
        <p className="md-inscripcion-examen__errors-footer">{parsed.footer}</p>
      ) : null}
    </div>
  );
}
